<template>
    <div class="vm-share" @click.self="open_menu" v-click-outside="close_menu">
        <div class="share-door" @click="open_menu">
            <i class="afd afd-share fs20"></i>
            <span v-if="!is_only_icon" class="flex-shrink-0 icon-text">{{icon_text_pre}}</span>
        </div>
        <div class="share-link" ref="menu" :class="{top_show:is_top_show, badge:name == 'badge'}" v-show="is_show_menu">
            <div class="share-item pointer" v-if="config.html2canvas_element" @click="make_img">
                <div class="icon-box">
                    <i class="afd afd-download fs14"></i>
                </div>{{$t('c.Share.text1')}}
            </div>
            <div
                class="share-item pointer"
                v-if="config.post_id || config.group || config.album || config.plan || config.sale_list"
                @click="open_feed_preview"
            >
                <div class="icon-box">
                    <i class="afd afd-download fs14"></i>
                </div>{{$t('c.Share.text2')}}
            </div>
            <div
                class="share-item pointer"
                v-if="config.share_user"
                @click="$mixin_show_modal_share_img({user:config.share_user})"
            >
                <div class="icon-box">
                    <i class="afd afd-download fs14"></i>
                </div>{{$t('c.Share.text2')}}
            </div>
            <div v-if="!config.is_no_copy_url" class="share-item pointer" @click="copy">
                <div class="icon-box">
                    <i class="afd afd-share-link fs14"></i>
                </div>{{$t('c.Share.text3')}}
            </div>
            <div class="pl16 pr16">
                <div class="line"></div>
            </div>
            <a v-if="!config.is_no_weibo" class="share-item" target="_blank" :href="weibo">
                <div class="icon-box">
                    <pic
                        :src="`${this.GL.PIC_HOST}/static/img/weibo@2x.png`"
                        width="24"
                        height="24"
                    ></pic>
                </div>{{$t('c.Share.text4')}}
            </a>
            <a v-if="!config.is_no_qq" class="share-item" target="_blank" :href="qq">
                <div class="icon-box">
                    <pic :src="`${this.GL.PIC_HOST}/static/img/qq@2x.png`" width="24" height="24"></pic>
                </div>{{$t('c.Share.text5')}}
            </a>
            <a v-if="!config.is_no_douban" class="share-item" target="_blank" :href="douban">
                <div class="icon-box">
                    <pic
                        :src="`${this.GL.PIC_HOST}/static/img/douban@2x.png`"
                        width="24"
                        height="24"
                    ></pic>
                </div>{{$t('c.Share.text6')}}
            </a>
            <div v-if="!config.is_no_wechat" class="share-item pointer" @click="open_qr">
                <div class="icon-box">
                    <pic
                        :src="`${this.GL.PIC_HOST}/static/img/wechat@2x.png`"
                        width="24"
                        height="24"
                    ></pic>
                </div>{{$t('c.Share.text7')}}
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { POST_MY_CREATOR_SHARE_PAGE } from "@/api/config";

export default {
  name: "btn",
  props: {
    config: {
      type: Object,
      default() {
        return {
          url: window.location.href,
          source: "https://afdian.net",
          title: document.title,
          description: `分享爱发电 | 连接创作者与粉丝的会员制平台`,
          pic: "",
          is_no_weibo: false,
          is_no_qq: false,
          is_no_douban: false,
          is_no_wechat: false,
          post_id: "",
          this_user: null,
          share_user: null,
          group: null,
          album: null,
          plan: null,
          members: [],
          sale_list: [],
          sku_list: [],
        };
      }
    },
    icon_text:{
      default() {
        return '';
      }
    },
    is_need_todo: {
      default() {
        return false;
      }
    },
    is_only_icon: {
      default() {
        return false;
      }
    },
    name:{
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      icon_text_pre: this.icon_text || this.$t('c.Share.text8'),
      is_show_menu: false,
      is_top_show: false
    };
  },
  computed: {
    ...mapState("app", ["browser_size", "session_user"]),
    weibo() {
      let target_url = "http://service.weibo.com/share/share.php";
      let config = {
        url: this.config.url,
        title: this.config.description,
        pic: this.config.pic,
        channel: "weibo",
        appkey: "6512497131"
      };
      return target_url + "?" + this.$params(config);
    },
    qq() {
      let target_url = "https://connect.qq.com/widget/shareqq/index.html";
      let config = {
        url: this.config.url,
        source: this.config.source,
        channel: "qq",
        desc: this.config.description
      };
      return target_url + "?" + this.$params(config);
    },
    douban() {
      let target_url = "https://www.douban.com/share/service";
      let config = {
        href: this.config.url,
        name: this.config.title,
        text: this.config.description,
        image: this.config.pic,
        channel: "douban"
      };
      return target_url + "?" + this.$params(config);
    },
    qq_schema() {
      let target_url =
        "mqqapi://share/to_fri?src_type=web&version=1&file_type=news&share_id=11016856830&thirdAppDisplayName=5aW254mb5YWz";
      let config = {
        url: this.config.url,
        title: this.config.title,
        description: this.config.description,
        pic: `${this.GL.PIC_HOST}/static/img/qq@2x.png?imageView2/1/w/120/h/120`,
        image: `${this.GL.PIC_HOST}/static/img/qq@2x.png?imageView2/1/w/120/h/120`,
        img: `${this.GL.PIC_HOST}/static/img/qq@2x.png?imageView2/1/w/120/h/120`,
        channel: "qq_client"
      };
      return target_url + "&" + this.$params(config, true);
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    open_qr() {
      this.$modal.show(
        () => import("@/components/ModalQr"),
        {
          val: this.config.url
        },
        {
          height: "auto",
          width: 300
        }
      );
    },
    open_menu() {
      if (this.GL.ENV.is_afd_client) {
        this.$bridge.call("share", this.config, () => {});
        return false;
      }

      if (
        this.is_need_todo &&
        this.session_user &&
        this.session_user.creator &&
        this.session_user.creator.todo_status == 0
      ) {
        this.action_todo();
      }
      if (this.browser_size == "small") {
        this.$modal.show(
          () => import("@/components/ModalShareMobile"),
          {
            weibo: this.config.is_no_weibo ? "" : this.weibo,
            douban: this.config.is_no_douban ? "" : this.douban,
            qq: this.config.is_no_qq ? "" : this.qq,
            wechat: this.config.is_no_wechat ? "" : this.config.url,
            url: this.config.is_no_copy_url ? '': this.config.url,
            qq_schema: this.qq_schema,
            html2canvas_element: this.config.html2canvas_element,
            post_id: this.config.post_id,
            this_user: this.config.this_user,
            share_user: this.config.share_user,
            group: this.config.group,
            album: this.config.album,
            badge: this.config.badge,
            filename: this.config.filename,
            plan: this.config.plan,
            members: this.config.members,
            sale_list: this.config.sale_list,
            sku_list: this.config.sku_list,
          },
          {
            classes: "v--modal-share-mobile v--modal",
            height: "auto",
            width: document.body.clientWidth - 32,
            name: "ModalShareMobile"
          }
        );
        return false;
      }
      this.is_show_menu = !this.is_show_menu;
      this.$nextTick(() => {
        if (this.browser_size != "small") {
          if(name == 'badge'){

          }
          if (
            this.$el.offsetTop +
              this.$el.clientHeight +
              this.$refs.menu.clientHeight +
              10 >
            document.body.clientHeight
          ) {
            this.is_top_show = true;
          } else {
            this.is_top_show = false;
          }
        }
      });
    },
    close_menu() {
      this.is_show_menu = false;
    },
    copy() {
      this.mixin_copy(this.config.url);
    },
    async action_todo() {
      if (this.$http.is_run(POST_MY_CREATOR_SHARE_PAGE)) {
        return false;
      }
      await this.$http.$axios(POST_MY_CREATOR_SHARE_PAGE);
    },
    async make_img() {
      this.$emit("close");
      this.$nextTick(async () => {
        let img = await this.mixin_make_pic(this.config.html2canvas_element, 3);
        this.$mixin_make_download(img.src, this.config.filename || "share");
      });
    },
    open_feed_preview() {
      let data = {};
      if (this.config.post_id) {
        data = {
          val: `https://afdian.net/p/${this.config.post_id}`,
          user: this.config.this_user,
          post_id: this.config.post_id
        };
      }
      if (this.config.group) {
        data = {
          group: this.config.group,
          plan: this.config.plan,
          members: this.config.members
        };
      }
      if (this.config.album) {
        data = {
          album: this.config.album
        };
      }
      if(this.config.plan && !this.config.group){
        data = {
          plan: this.config.plan,
          sku_list:this.config.sku_list
        };
      }
      if(this.config.sale_list){
        data = {
          sale_list: this.config.sale_list,
          user: this.config.this_user,
        };
      }
      if (this.config.badge) {
        data = {
          badge: this.config.badge
        };
      }
      this.$mixin_show_modal_share_img(data);
    },
    open_img(src) {
      // this.$mixin_show_modal_img(0, [src], "0", "请长按图片保存");
      // let img_result = this.$img_type(src)
      // this.$modal.show(() => import('@/components/ModalImg'), {
      //     tip:'请手动保存下方图片',
      //     src:src,
      //     width: 'screen',
      //     height:'screen',
      // },{
      //     classes:'v--modal-img v--modal',
      //     height: document.body.clientHeight,
      //     width: 480,
      // })
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-share {
    color: $black-3;
    font-size: 14px;
    position: relative;
    cursor: pointer;

    &.white {
        color: $white;
    }
    &.purple {
        color: $purple;
    }
    &.tag{
      
    }

    &.purple-icon {
        .afd-share {
            color: $purple;
        }
    }
    &.fs16{
        .afd{
            font-size:16px !important;
        }
    }
    &.fs14{
        .afd{
            font-size:14px !important;
        }
    }

    &.btn {
        border-radius: px2rem(2);
        background: linear-gradient(90deg, $purple, $purple-deep);
        color: $white;
        padding: px2rem(8) px2rem(24);
    }

    .share-door {
        align-items: center;
        display: flex;
        cursor: pointer;
    }
    &.type3{
      background: rgba(148, 108, 230, 0.1);
      border-radius: 15px;
      padding:6px 12px;
      .afd{
          font-size:14px !important;
      }
    }
    &.type2{
      font-weight:normal;
      color:$black-3;
      padding:6px 8px;
      background: #FAFAFA;
      border-radius: 15px;
      .afd-share{
        font-size:14px !important;
        color:$black-3;
      }
      .icon-text{
        margin-left:4px;
      }
      
    }
    .icon-text{
      margin-left:8px;
    }

    // .afd-share {
    // margin-right: px2rem(8);
    // }
    .share-link {
        position: absolute;
        bottom: _px2rem(8);
        right: 0;
        border: 1px solid $black-1;
        border-radius: px2rem(4);
        transform: translateY(100%);
        z-index: 1;
        box-shadow: $layer-shadow;

        &.top_show {
            bottom: 0;
            transform: translateY(_px2rem(40));
        }
        &.badge{
          bottom: 0px;
          transform: translate(16%,-37px);
        }
    }

    .share-item {
        display: flex;
        align-items: center;
        color: $black-5;
        padding: px2rem(8) px2rem(32) px2rem(8) px2rem(16);
        background: $white;
        white-space: nowrap;

        .icon-box {
            width: px2rem(24);
            height: px2rem(24);
            margin-right: px2rem(8);
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                display: block;
            }
        }

        &:hover {
            background: $white-bg;
            color: $black;
        }

        &:first-child {
            border-top-left-radius: px2rem(4);
            border-top-right-radius: px2rem(4);
        }

        &:last-child {
            border-bottom-left-radius: px2rem(4);
            border-bottom-right-radius: px2rem(4);
        }
    }
    // .pic-box {
    //     position: relative;
    //     padding-bottom: 22.22%; // 320/1440

    //     img {
    //     position: absolute;
    //     object-fit: cover;
    //     height: 100%;
    //     }
    // }
}
</style>
